import { render } from "./OfferDetailsModal.vue?vue&type=template&id=b9ed57b6&scoped=true"
import script from "./OfferDetailsModal.vue?vue&type=script&lang=js"
export * from "./OfferDetailsModal.vue?vue&type=script&lang=js"

import "./OfferDetailsModal.vue?vue&type=style&index=0&id=b9ed57b6&lang=scss"
import "./OfferDetailsModal.vue?vue&type=style&index=1&id=b9ed57b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ed57b6"],['__file',"webpack-assets/vue/templates/product/catalog/parts/OfferDetailsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9ed57b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9ed57b6', __exports__)) {
    api.reload('b9ed57b6', __exports__)
  }
  
  module.hot.accept("./OfferDetailsModal.vue?vue&type=template&id=b9ed57b6&scoped=true", () => {
    api.rerender('b9ed57b6', render)
  })

}


export default __exports__